import { useQuery } from "@tanstack/react-query";
import { getPreInvoiceList } from "../api/preInvoiceApi";
import { preInvoiceKeys } from "../api/preInvoiceKeys";

// Listado de prefacturas del colaborador.
export const usePreInvoiceList = () =>
  useQuery({
    queryKey: preInvoiceKeys.list(),
    queryFn: getPreInvoiceList,
  });
